import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 bg-light p-3" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, " Roles", -1)
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table table-striped table-sm" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1)
const _hoisted_10 = { class: "text-start" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "btn-group mr-2" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "pagination" }
const _hoisted_16 = { class: "page-item" }
const _hoisted_17 = { class: "page-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_router_link, {
            to: "/roles/create",
            class: "btn btn-sm btn-primary align-self-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Add Roles")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.roles, (role) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: role.id
                }, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(role.id), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(role.name), 1),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_router_link, {
                        to: `/roles/${role.id}/edit`,
                        class: "btn btn-sm btn-secondary me-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Edit")
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("a", {
                        class: "btn btn-sm btn-danger me-2",
                        onClick: ($event: any) => ($setup.del(role.id))
                      }, " Delete", 8, _hoisted_14)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("nav", null, [
          _createElementVNode("ul", _hoisted_15, [
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("a", {
                class: "page-link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.previous && $setup.previous(...args)))
              }, "Previous")
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createElementVNode("a", {
                class: "page-link",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
              }, "Next")
            ])
          ])
        ])
      ])
    ])
  ]))
}